<template>
  <InputValidator
    :class="$style.rowSpacing"
    :config="{
      attribute: 'email',
      label: 'Distribution Group Email',
      name: 'email',
      validate: 'email',
      value: email,
    }"
    :tooltip="tooltip"
    @InputValidatorModel="handleManagementGroupInputChange"
  />
</template>
<script>
import {
  DirectoryNameConsts, DirectoryTypeConsts, ItemTypeConsts, StoreModelMap,
} from 'client/util/Constants';
import { mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import InputValidator from 'client/components/FormValidation/InputValidator.vue';

const googleDisplayName = DirectoryNameConsts[DirectoryTypeConsts.gSuite];
const userGroupModel = StoreModelMap[ItemTypeConsts.userGroup];

export default {
  name: 'ManagementGroupInput',

  inject: ['$validator'],

  components: {
    InputValidator,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data() {
    return {
      tooltip: {
        text: `This user group is part of a ${googleDisplayName} directory that is enabled for the management of groups and memberships within ${googleDisplayName}.`,
      },
    };
  },

  computed: {
    ...mapState(userGroupModel, {
      email: state => state.item.email,
    }),
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
  },

  methods: {
    handleManagementGroupInputChange(value, key) {
      this.setItemField({ key, value });
    },
  },
};
</script>
<style module>
@import '../../components/FormValidation/css/formFields.css';

</style>
